<template>

    <main id="main" class="ms-sm-auto">
        <link href="/themes/web/assets/css/unit-detail.css" rel="stylesheet" />

        <div class="container">

            <div id="page-header-fixed">
                <div class="">
                    <div id="page-header" class="d-flex">
                        <ul class="breadcrumb flex">
                            <li @click="$router.go(-1)" class="icon"><img src="/themes/web/assets/images/back-to.svg" alt=""></li>
                            <li class="active">Assignment - {{name_lesson}}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="mark-lesson"></div>
            <div class="card">
                <div class="pratice">
                    <div class="lesson-action-button">
                        <span>+</span>
                    </div>
                    <div class="card-content" style="height: calc(100vh - 285px); padding: 0px; min-height: 550px;">
                        <iframe width="100%" height="100%" src="/themes/web/assignments-4.html" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>            

        </div>
    </main>

</template>

<script>
import axios from "axios";
import { getAssignments } from '../../models/assignment';
import AssigmentItem from './AssigmentItem.vue';

export default {
  components: { AssigmentItem },
    name: "AssigmentDetail",
    title: "AssigmentDetail",

    data() {
        return {
            name_lesson: '',
            assignment: {},
            assignments: [],
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },

    created() {
       this.fetch();
    },

    methods: {
        fetch() {
            const {lesson_id} = this.$route.params;

            this.lesson_id = lesson_id;

            this.getAssignments();
        },

        async getAssignments() {
            const that = this;

            that.isLoading = true;

            await axios.all([
                getAssignments({
                    lesson_id: that.lesson_id
                }),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                if (response.data.code != 0) {
                    return;
                }

                that.name_lesson = response.data.results.name_lesson;
                that.assignments = response.data.results.assignments || [];
            }));
        },        
    },
};
</script>

<style scoped>

</style>
